
const enum ExpenseType {
    'Normal',
    'Special'

};
import { Marketdate } from '../marketdate';
import { User } from '../../shared';
export class MarketdateExpense {
    constructor(
        public id?: number,
        public description?: string,
        public value?: number,
        public expenseType?: ExpenseType,
        public updated?: any,
        public created?: any,
        public image?: any,
        public marketdate?: Marketdate,
        public updatedBy?: User,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-expense/marketdate-expense.model.ts